import React, { useEffect, useState } from 'react';
import { FiDownload, FiUpload, FiPlus } from 'react-icons/fi';
import { cancelAnketa, deletePhoto, updateAnketa, uploadPhoto } from '../Slots/slotsApi'; // заменили импорт

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const AnketaModal = ({ anketa, onClose, setPhotosArr, photosArr }) => {
    const [intention, setIntention] = useState(anketa?.intention || '');
    const [fullName, setFullName] = useState(anketa?.fullName || '');
    const [isSaving, setIsSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [error, setError] = useState('');
    

    console.log('anketa', anketa)

    // useEffect(() => {
    //     if (anketa?.photos) {
    //         setPhotosArr(anketa.photos.split('|'));
    //     }
    // }, [anketa?.photos]);

    useEffect(() => {
        setIntention(anketa?.intention || '');
        setFullName(anketa?.fullName || '');
    }, [anketa]);

    if (!anketa) return null;

    // const photosArr = anketa.photos ? anketa.photos.split('|') : [];

    const handleDownload = (url) => {
        const link = document.createElement('a');
        link.href = `${API_BASE_URL}/${url}`;
        link.setAttribute('download', 'photo.jpg'); // или своё имя
        link.setAttribute('target', '_blank');      // если хочешь, чтобы открывалось во вкладке
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleRemoveServerPhoto = async (indexToRemove) => {
        try {
            const updatedPhotos = await deletePhoto(anketa.id, indexToRemove);
            const updatedArr = updatedPhotos.replace(/^"|"$/g, '').split('|');

            setPhotosArr(updatedArr);

            // Обновляем объект anketa локально
            anketa.photos = updatedArr.join('|');
        } catch (error) {
            console.error('Ошибка при удалении фото:', error);
        }
    };



    const handleUpload = async (file, index) => {
        try {
            const formData = new FormData();
            formData.append('photo', file);
            formData.append('anketaId', anketa.id);
            formData.append('photoIndex', index); // индекс фото, если нужно заменить конкретное

            const updatedPhotos = await uploadPhoto(formData); // ожидаем новый список фото
            console.log('updatedPhotos', updatedPhotos.replace(/^"|"$/g, '').split('|'))
            setPhotosArr(
                updatedPhotos.replace(/^"|"$/g, '').split('|')
            );
        } catch (error) {
            console.error('Ошибка при загрузке фото:', error);
        }
    };

    const handleSave = async () => {
        setIsSaving(true);
        setError('');
        try {
            await updateAnketa(anketa.id, intention, fullName);
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 2000);
        } catch (err) {
            console.error(err);
            setError('Ошибка при сохранении');
        } finally {
            setIsSaving(false);
        }
    };

    const handleCancelSlot = async (anket_id) => {
        if (!window.confirm('Вы уверены, что хотите отменить запись?')) return;

        try {
            await cancelAnketa(anket_id);
            onClose()
        } catch (err) {
            alert('Ошибка при отмене записи: ' + err.message);
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{ background: '#fff', padding: 20, borderRadius: 8, width: '80%', maxHeight: '80%', overflowY: 'auto' }}
                onClick={e => e.stopPropagation()}
            >
                <button
                    style={{ position: 'absolute', top: '80px', right: '150px' }}
                    className="btn_cancel"
                    onClick={() => handleCancelSlot(anketa.id)}
                >
                    Отменить запись
                </button>
                <h2>Информация об анкете</h2>

                <div style={{ marginBottom: 10 }}>
                    <strong>ФИО:</strong><br />
                    <input
                        type="text"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        style={{ width: '100%', marginTop: 4 }}
                    />
                </div>
                <p><strong>Email:</strong> {anketa.email}</p>
                <p><strong>Телефон:</strong> {anketa.phone}</p>
                <p><strong>Страна:</strong> {anketa.country}</p>
                <p><strong>Диагноз:</strong> {anketa.diagnosis}</p>

                <p><strong>Планирует ли присутствовать:</strong> {anketa.presence || 'Не указано'}</p>
                <p><strong>Согласие на отказ при отсутствии:</strong> {anketa.presenceAgreement ? 'Да' : 'Нет'}</p>
                {anketa.presence === 'no' && (
                    <p><strong>Причина отсутствия:</strong> {anketa.presenceReason || 'Не указана'}</p>
                )}

                <div style={{ marginBottom: 10 }}>
                    <strong>Намерение:</strong><br />
                    <textarea
                        value={intention}
                        onChange={(e) => setIntention(e.target.value)}
                        style={{ width: '100%', minHeight: 80, marginTop: 4 }}
                    />
                    <div style={{ marginTop: 6 }}>
                        <button className='btn_admin' onClick={handleSave} disabled={isSaving}>
                            {isSaving ? 'Сохраняю...' : 'Сохранить'}
                        </button>
                        {saveSuccess && <span style={{ marginLeft: 10, color: 'green' }}>Сохранено ✅</span>}
                        {error && <span style={{ marginLeft: 10, color: 'red' }}>{error}</span>}
                    </div>
                </div>

                <p><strong>Согласие по имени:</strong> {anketa.agreebyname}</p>
                <p><strong>Участие в ретрите:</strong> {anketa.retreat ? 'Да' : 'Нет'}</p>
                <p><strong>Возраст:</strong> {anketa.age}</p>
                <p><strong>Отношение:</strong> {anketa.relation}</p>

                {/* <div>
                    <strong>Фото:</strong>
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 8 }}>
                        {photosArr.length > 0
                            ? photosArr.map((photo, i) => (
                                <img
                                    key={i}
                                    src={`${API_BASE_URL}/${photo}`}
                                    alt={`Фото ${i + 1}`}
                                    style={{ maxWidth: 100, maxHeight: 100, objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc' }}
                                    onError={(e) => e.target.style.display = 'none'}
                                />
                            ))
                            : <span>Фото не добавлены</span>
                        }
                    </div>
                </div> */}
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <strong>Фото:</strong>
                        <label title="Добавить фото" style={{ cursor: 'pointer' }}>
                            <FiPlus size={20} />
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={(e) => handleUpload(e.target.files[0], photosArr.length)}
                            />
                        </label>
                    </div>


                    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 8 }}>
                        {photosArr.length > 0 ? photosArr.map((photo, i) => (
                            <div key={i} style={{ textAlign: 'center', position: 'relative' }}>
                                <img
                                    src={`${API_BASE_URL}/${photo}`}
                                    alt={`Фото ${i + 1}`}
                                    style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: 8, border: '1px solid #ccc' }}
                                    onError={(e) => e.target.style.display = 'none'}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemoveServerPhoto(i)}
                                    style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        background: 'red',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                        lineHeight: '18px',
                                        padding: 0
                                    }}
                                    title="Удалить фото"
                                >
                                    ×
                                </button>
                                <div style={{ marginTop: 6, display: 'flex', justifyContent: 'center', gap: 10 }}>
                                    <button onClick={() => handleDownload(photo)} title="Скачать" style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
                                        <FiDownload size={20} />
                                    </button>
                                    <label title="Загрузить" style={{ cursor: 'pointer' }}>
                                        <FiUpload size={20} />
                                        <input type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleUpload(e.target.files[0], i)} />
                                    </label>
                                </div>
                            </div>
                        )) : <span>Фото не добавлены</span>}
                    </div>
                </div>

                <button className='btn_admin' style={{ marginTop: 20 }} onClick={onClose}>Закрыть</button>
            </div>
        </div>
    );
};

export default AnketaModal;
